import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '@haleo-frontend/utils';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-new-popover',
    templateUrl: 'new-popover.modal.html',
    styleUrls: ['new-popover.modal.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NewPopoverModal extends AbstractComponent {

    @Input() title: string;
    @Input() titleColor: string;
    @Input() description: string;
    @Input() icon: string;
    @Input() hideCloseButton: boolean;
    @Input() buttons: Array<{ handler: any, label: string, type: string, color: string }>;
    @Input() notificationSettings: boolean;

    constructor(private modalController: ModalController) {
        super();
    }

    close() {
        this.modalController.dismiss();
    }
}
